import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import StudentSidebar from './StudentSidebar';
import BottomNav from './BottomNav';
import './Layout.css';
import API from '../services/api';

const Layout = ({ children, role }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    // Retest notifications removed
  }, [role]);

  return (
    <div className="app-layout">
      <Navbar 
        onMenuClick={() => setSidebarOpen(true)} 
        notifCount={notifCount} 
        userRole={role}
      />
      
      {role === 'admin' || role === 'super_admin' ? (
        <Sidebar mobileOpen={sidebarOpen} setMobileOpen={setSidebarOpen} notifCount={notifCount} isManaged />
      ) : (
        <StudentSidebar mobileOpen={sidebarOpen} setMobileOpen={setSidebarOpen} isManaged />
      )}

      {sidebarOpen && (
        <div className="mobile-overlay" onClick={() => setSidebarOpen(false)}></div>
      )}

      <main className="main-viewport">
        <div className="content-container">
          {children}
        </div>
      </main>

      <BottomNav role={role} />
    </div>
  );
};

export default Layout;
